import { Control, Controller, RegisterOptions } from "react-hook-form";
import { NGInput, NGInputProps } from "../../../../newcomponents/input/input";

interface FormNGInputProps extends Omit<NGInputProps, "value" | "onChange" | "onBlur"> {
  name: string;
  control: Control<any>;
  rules?: RegisterOptions;
}

export const FormNGInput = ({ name, control, rules, ...props }: FormNGInputProps) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => (
        <NGInput {...props} {...field} invalid={fieldState.invalid || !!fieldState.error} />
      )}
    />
  );
};
